<template>
  <div class="con">
    <!-- 头部 -->
    <headbox></headbox>
    <!-- 内容 -->
    <ours></ours>
    <!-- 底部 -->
    <footbox></footbox>
  </div>
</template>

<script>
import headbox from './components/home/headbox' 

import ours from './components/ours'
import footbox from './components/footbox'
export default {
  components: {
    headbox,
    ours,
    footbox,
  },
  data () {
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
</style>
